import { settingApi } from "api/TenantSlug/Setting/api.ts";

export function composeSettingsQueryOptions() {
    return {
        queryKey: ["getSettings"],
        queryFn: () => settingApi.index(),
    };
}

export function getSettingsQueryOptions() {
    return {
        ...composeSettingsQueryOptions(),
        suspense: true,
    };
}
